import { render } from "./ListeSecteurParametresPage.vue?vue&type=template&id=208bcd3a&ts=true"
import script from "./ListeSecteurParametresPage.vue?vue&type=script&lang=ts"
export * from "./ListeSecteurParametresPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__